export enum CollectionType {
    Journey = 1,
    Theme = 2,
    Premium = 3
}

export enum CollectionStatus {
    Published = 1,
    Unpublished = 2
}

export const CollectionOptions = {
    Type: [
        { value: CollectionType.Journey, label: 'Journey', background: 'success' },
        { value: CollectionType.Theme, label: 'Theme', background: 'success' },
        { value: CollectionType.Premium, label: 'Premium', background: 'info' }
    ]
};

export const CollectionSelectOptions = {
    Type: [
        { value: CollectionType.Journey, label: 'Journey', background: 'success' },
        { value: CollectionType.Theme, label: 'Theme', background: 'success' },
        { value: CollectionType.Premium, label: 'Premium', background: 'info' }
    ],
    Status: [
        { value: CollectionStatus.Published, label: 'Published', background: 'success' },
        { value: CollectionStatus.Unpublished, label: 'Unpublished', background: 'warning' }
    ]
};
